/**
 * Labstep
 */

import type { EntityView } from 'labstep-web/models/entity-view.model';
import React, { createContext, useEffect, useState } from 'react';
import type { ParamsStateContextType } from './types';

export const ParamsStateContext =
  createContext<ParamsStateContextType>({
    name: undefined,
    destination: undefined,
    entityView: undefined,
    loadedEntityView: undefined,
    setEntityView: undefined,
    globalParams: undefined,
    initialSearchParams: undefined,
    isGrid: false,
    injectFields: undefined,
  });

export const ParamsStateContextProvider: RFC<{
  value: ParamsStateContextType;
}> = ({ value, children }) => {
  const [entityView, setEntityView] = useState<EntityView | null>(
    value.entityView || null,
  );

  useEffect(() => {
    if (value.entityView && value.entityView !== entityView) {
      if (entityView && entityView.id && !entityView.deleted_at) {
        value.entityView.column_options = entityView.column_options;
      }
      setEntityView(value.entityView || null);
    }
  }, [value.entityView]);

  return (
    <ParamsStateContext.Provider
      value={{
        ...value,
        entityView,
        setEntityView,
      }}
      children={children}
    />
  );
};
